export default "__VITE_ASSET__CGrTtanI__"